import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { DEFAULT_THEME } from "./constants/default-theme";
import { Head } from "./internal-components/Head";
import { ThemeProvider } from "./internal-components/ThemeProvider";
import { OuterErrorBoundary } from "./prod-components/OuterErrorBoundary";
import { router } from "./router";
import { GoogleOAuthProvider } from "@react-oauth/google";
import toast, { Toaster, ToastBar } from "react-hot-toast";
import useAuthStore from "./utils/authStore";

export const AppWrapper = () => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  const { token, selectedProjectId, fetchSelectedProject } = useAuthStore();

  useEffect(() => {
    // Fetch selected project on app initialization if user is authenticated
    if (token && selectedProjectId) {
      fetchSelectedProject();
    }
  }, [token, selectedProjectId, fetchSelectedProject]);

  return (
    <OuterErrorBoundary>
      <GoogleOAuthProvider clientId={clientId}>
        <ThemeProvider defaultTheme={DEFAULT_THEME}>
          <RouterProvider router={router} />
          <Head />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#333',
                color: '#fff',
              },
              success: {
                style: {
                  background: '#10b981',
                },
              },
              error: {
                style: {
                  background: '#ef4444',
                },
              },
            }}
          >
            {(t) => (
              <ToastBar toast={t}>
                {({ icon, message }) => (
                  <>
                    {message}
                    <button
                      onClick={() => toast.dismiss(t.id)}
                      style={{ marginLeft: 8, background: 'transparent', border: 'none', color: 'inherit', cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: '0 2px' }}
                      aria-label="Dismiss"
                    >
                      ×
                    </button>
                  </>
                )}
              </ToastBar>
            )}
          </Toaster>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </OuterErrorBoundary>
  );
};
